import { defineMessages } from 'react-intl';

export default defineMessages({
    header: {
        id: '_.funding_requirements.header',
        defaultMessage:
            "You're drawing down {drawdownAmount} with repayments over {loanDuration}{tooltip}"
    },
    interestOnlyHeader: {
        id: '_.funding_requirements.interestOnlyHeader',
        defaultMessage: 'Your loan with repayments over {loanDuration}'
    },
    rcfFirstDrawdownHeader: {
        id: '_.funding_requirements.rcf_first_drawdown_header',
        defaultMessage:
            'You have chosen the Flexi credit line with {drawdownAmount}'
    },
    rcfSubsequentDrawdownHeader: {
        id: '_.funding_requirements.rcf_subsequent_drawdown_header',
        defaultMessage: 'You are withdrawing further {drawdownAmount}'
    },
    accessUserHeader: {
        id: '_.funding_requirements.accessUserHeader',
        defaultMessage:
            'You are guaranteeing a loan of {drawdownAmount} with repayments over {loanDuration}'
    },
    duration: {
        id: '_.funding_requirements.duration',
        defaultMessage: '{loanDuration} months'
    },
    tooltip: {
        id: '_.funding_requirements.tooltip',
        defaultMessage:
            "You can adjust your choice by clicking 'Go back' below."
    },
    subHeader: {
        id: '_.funding_requirements.subheader',
        defaultMessage:
            'Before we can send funds to your account, we need you to complete a few final steps.'
    },
    interestOnlySubHeader: {
        id: '_.funding_requirements.interestOnlySubHeader',
        defaultMessage:
            'Before we can extend your loan, you need to complete a few final steps'
    },
    rcfFirstDrawdownSubHeader: {
        id: '_.funding_requirements.rcf_first_drawdown_subheader',
        defaultMessage:
            'To activate your credit line, we kindly ask you to complete the following final steps.'
    },
    rcfSubsequentDrawdownSubHeader: {
        id: '_.funding_requirements.rcf_subseqeuent_drawdown_subheader',
        defaultMessage:
            'Before we transfer the money to your account, you need to complete a few final steps.'
    },
    repaymentReductionSubHeader: {
        id: '_.funding_requirements.repayment_reduction_subheader',
        defaultMessage:
            'Before we can reduce your monthly repayments, you need to complete a few final steps.'
    },
    accessUserSubHeader: {
        id: '_.funding_requirements.accessUserSubHeader',
        defaultMessage:
            'Before we can send funds to {businessName}, we need you to complete a few final steps.'
    },
    loadingText: {
        id: '_.funding_requirements.loading_text',
        defaultMessage: 'One moment, we’re checking your status...'
    },
    backButton: {
        id: '_.funding_requirements.back_button',
        defaultMessage: 'Go back'
    },
    incompleteTabTitle: {
        id: '_.funding_requirements.incomplete_tab_title',
        defaultMessage: 'Incomplete'
    },
    completeTabTitle: {
        id: '_.funding_requirements.complete_tab_title',
        defaultMessage: 'Complete'
    }
});
